import { render, staticRenderFns } from "./SavedSearches.vue?vue&type=template&id=4843dfa8&scoped=true"
import script from "./SavedSearches.vue?vue&type=script&lang=ts"
export * from "./SavedSearches.vue?vue&type=script&lang=ts"
import style0 from "./SavedSearches.vue?vue&type=style&index=0&id=4843dfa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843dfa8",
  null
  
)

export default component.exports